import styled from '@emotion/styled';

export const BreadcrumbsSection = styled.div`
  padding-top: ${({ theme }) => theme.spacing(5)};
  border-top: 1px solid ${({ theme }) => theme.colors.neutrals.grey7};
`;

